import { UserType } from 'Core/interfaces/core'

import { Permission } from 'Portals/Supplier/constants'

export enum MenuKey {
	// INJECT_FROM_PLOP_TABLELIST
	DOCUMENT = 'Document',
	DASHBOARD = 'Dashboard',
	PROFILE = 'Profile',
	REPORTS = 'Reports',
	INVOICES = 'Invoices',
	HELP_CENTER = 'Help Center',
	SITE_VISITS = 'Site Visits'
}

export const menuItemsByUserPermissions: Partial<{ [key in MenuKey]: Permission[] }> = {
	[MenuKey.REPORTS]: [Permission.REPORTING_VIEW]
}

export const menuItemsByUserTypes: Partial<{ [key in MenuKey]: UserType[] }> = {
	[MenuKey.DASHBOARD]: [UserType.SUPPLIER],
	[MenuKey.INVOICES]: [UserType.SUPPLIER, UserType.ACCOUNTS_PAYABLE],
	[MenuKey.REPORTS]: [UserType.SUPPLIER],
	[MenuKey.SITE_VISITS]: [UserType.SUPPLIER],
	[MenuKey.DOCUMENT]: [UserType.SUPPLIER],
	[MenuKey.PROFILE]: [UserType.SUPPLIER],
	[MenuKey.HELP_CENTER]: [UserType.SUPPLIER]
}
